// React Imports
import type { SVGAttributes } from 'react';

export const Calendar = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path
        d="M14.56 1.45V0.9C14.56 0.4 14.16 0 13.66 0C13.16 0 12.76 0.4 12.76 0.9V1.42H7.05V0.9C7.05 0.4 6.65 0 6.15 0C5.65 0 5.25 0.4 5.25 0.9V1.45C2.31 1.73 0 4.22 0 7.23V14.65C0 17.85 2.61 20.46 5.81 20.46H13.99C17.19 20.46 19.8 17.85 19.8 14.65V7.23C19.8 4.22 17.5 1.74 14.56 1.45ZM5.25 3.28V4.26C5.25 4.76 5.65 5.16 6.15 5.16C6.65 5.16 7.05 4.76 7.05 4.26V3.22H12.76V4.26C12.76 4.76 13.16 5.16 13.66 5.16C14.16 5.16 14.56 4.76 14.56 4.26V3.28C16.2 3.52 17.52 4.74 17.89 6.33H1.91C2.28 4.73 3.6 3.51 5.25 3.28ZM13.99 18.66H5.81C3.6 18.66 1.8 16.86 1.8 14.65V8.13H18V14.65C18 16.86 16.2 18.66 13.99 18.66Z"
        fill="#424242"
      />
      <path
        d="M6.49969 10.0391H5.07969C4.57969 10.0391 4.17969 10.4391 4.17969 10.9391C4.17969 11.4391 4.57969 11.8391 5.07969 11.8391H6.49969C6.99969 11.8391 7.39969 11.4391 7.39969 10.9391C7.39969 10.4391 6.99969 10.0391 6.49969 10.0391Z"
        fill="#424242"
      />
      <path
        d="M10.6481 10.0391H9.22812C8.72812 10.0391 8.32812 10.4391 8.32812 10.9391C8.32812 11.4391 8.72812 11.8391 9.22812 11.8391H10.6481C11.1481 11.8391 11.5481 11.4391 11.5481 10.9391C11.5481 10.4391 11.1481 10.0391 10.6481 10.0391Z"
        fill="#424242"
      />
      <path
        d="M6.49969 13.1504H5.07969C4.57969 13.1504 4.17969 13.5504 4.17969 14.0504C4.17969 14.5504 4.57969 14.9504 5.07969 14.9504H6.49969C6.99969 14.9504 7.39969 14.5504 7.39969 14.0504C7.39969 13.5504 6.99969 13.1504 6.49969 13.1504Z"
        fill="#424242"
      />
      <path
        d="M10.6481 13.1504H9.22812C8.72812 13.1504 8.32812 13.5504 8.32812 14.0504C8.32812 14.5504 8.72812 14.9504 9.22812 14.9504H10.6481C11.1481 14.9504 11.5481 14.5504 11.5481 14.0504C11.5481 13.5504 11.1481 13.1504 10.6481 13.1504Z"
        fill="#424242"
      />
      <path
        d="M14.7262 10.0391H13.3062C12.8062 10.0391 12.4062 10.4391 12.4062 10.9391C12.4062 11.4391 12.8062 11.8391 13.3062 11.8391H14.7262C15.2262 11.8391 15.6262 11.4391 15.6262 10.9391C15.6262 10.4391 15.2262 10.0391 14.7262 10.0391Z"
        fill="#424242"
      />
      <path
        d="M14.7262 13.1504H13.3062C12.8062 13.1504 12.4062 13.5504 12.4062 14.0504C12.4062 14.5504 12.8062 14.9504 13.3062 14.9504H14.7262C15.2262 14.9504 15.6262 14.5504 15.6262 14.0504C15.6262 13.5504 15.2262 13.1504 14.7262 13.1504Z"
        fill="#424242"
      />
    </svg>
  );
};

export const CalendarGold = (_props: SVGAttributes<SVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <path
        d="M14.56 1.45V0.900002C14.56 0.400002 14.16 0 13.66 0C13.16 0 12.76 0.400002 12.76 0.900002V1.42001H7.05V0.900002C7.05 0.400002 6.65 0 6.15 0C5.65 0 5.25 0.400002 5.25 0.900002V1.45C2.31 1.73 0 4.22 0 7.23V14.65C0 17.85 2.61 20.46 5.81 20.46H13.99C17.19 20.46 19.8 17.85 19.8 14.65V7.23C19.8 4.22 17.5 1.74 14.56 1.45ZM5.25 3.28001V4.26C5.25 4.76 5.65 5.16 6.15 5.16C6.65 5.16 7.05 4.76 7.05 4.26V3.22H12.76V4.26C12.76 4.76 13.16 5.16 13.66 5.16C14.16 5.16 14.56 4.76 14.56 4.26V3.28001C16.2 3.52001 17.52 4.74 17.89 6.33H1.91C2.28 4.73 3.6 3.51001 5.25 3.28001ZM13.99 18.65H5.81C3.6 18.65 1.8 16.85 1.8 14.64V8.12H18V14.64C18 16.85 16.2 18.65 13.99 18.65Z"
        fill="url(#paint0_linear_12653_293865)"
      />
      <path
        d="M6.49969 10.0391H5.07969C4.57969 10.0391 4.17969 10.4391 4.17969 10.9391C4.17969 11.4391 4.57969 11.8391 5.07969 11.8391H6.49969C6.99969 11.8391 7.39969 11.4391 7.39969 10.9391C7.39969 10.4391 6.99969 10.0391 6.49969 10.0391Z"
        fill="url(#paint1_linear_12653_293865)"
      />
      <path
        d="M10.6481 10.0391H9.22812C8.72812 10.0391 8.32812 10.4391 8.32812 10.9391C8.32812 11.4391 8.72812 11.8391 9.22812 11.8391H10.6481C11.1481 11.8391 11.5481 11.4391 11.5481 10.9391C11.5481 10.4391 11.1481 10.0391 10.6481 10.0391Z"
        fill="url(#paint2_linear_12653_293865)"
      />
      <path
        d="M6.49969 13.1406H5.07969C4.57969 13.1406 4.17969 13.5406 4.17969 14.0406C4.17969 14.5406 4.57969 14.9406 5.07969 14.9406H6.49969C6.99969 14.9406 7.39969 14.5406 7.39969 14.0406C7.39969 13.5406 6.99969 13.1406 6.49969 13.1406Z"
        fill="url(#paint3_linear_12653_293865)"
      />
      <path
        d="M10.6481 13.1406H9.22812C8.72812 13.1406 8.32812 13.5406 8.32812 14.0406C8.32812 14.5406 8.72812 14.9406 9.22812 14.9406H10.6481C11.1481 14.9406 11.5481 14.5406 11.5481 14.0406C11.5481 13.5406 11.1481 13.1406 10.6481 13.1406Z"
        fill="url(#paint4_linear_12653_293865)"
      />
      <path
        d="M14.7262 10.0391H13.3062C12.8062 10.0391 12.4062 10.4391 12.4062 10.9391C12.4062 11.4391 12.8062 11.8391 13.3062 11.8391H14.7262C15.2262 11.8391 15.6262 11.4391 15.6262 10.9391C15.6262 10.4391 15.2262 10.0391 14.7262 10.0391Z"
        fill="url(#paint5_linear_12653_293865)"
      />
      <path
        d="M14.7262 13.1406H13.3062C12.8062 13.1406 12.4062 13.5406 12.4062 14.0406C12.4062 14.5406 12.8062 14.9406 13.3062 14.9406H14.7262C15.2262 14.9406 15.6262 14.5406 15.6262 14.0406C15.6262 13.5406 15.2262 13.1406 14.7262 13.1406Z"
        fill="url(#paint6_linear_12653_293865)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12653_293865"
          x1="9.9"
          y1="0"
          x2="9.9"
          y2="20.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12653_293865"
          x1="5.78969"
          y1="10.0391"
          x2="5.78969"
          y2="11.8391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_12653_293865"
          x1="9.93812"
          y1="10.0391"
          x2="9.93812"
          y2="11.8391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_12653_293865"
          x1="5.78969"
          y1="13.1406"
          x2="5.78969"
          y2="14.9406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_12653_293865"
          x1="9.93812"
          y1="13.1406"
          x2="9.93812"
          y2="14.9406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_12653_293865"
          x1="14.0162"
          y1="10.0391"
          x2="14.0162"
          y2="11.8391"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_12653_293865"
          x1="14.0162"
          y1="13.1406"
          x2="14.0162"
          y2="14.9406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBE66" />
          <stop offset="0.34" stopColor="#EDB05D" />
          <stop offset="1" stopColor="#CA7701" />
        </linearGradient>
      </defs>
    </svg>
  );
};
